import React from 'react'
import styled, { css } from 'styled-components'

const Button = ({ leftIcon, rightIcon, children, ...otherProps }) => {
  return (
    <WrapButton {...otherProps}>
      {leftIcon && <i className={`fas ${leftIcon}`}></i>}
      {children}
      {rightIcon && <i className={`fas ${rightIcon}`}></i>}
    </WrapButton>
  )
}

const WrapButton = styled.button.attrs((props) => ({ className: props.className }))`
  color: white;
  font-size: 13px;
  background: #00a8eb;
  padding: 15px;
  border: none;
  ${({ cancel }) =>
    cancel &&
    css`
      background: transparent;
      color: #00a8eb;
    `}
  ${({ grey }) =>
    grey &&
    css`
      background: #eeeeee;
      color: #555555;
    `}
  &:hover {
    opacity: 0.7;
  }
`
export default Button
